export default __webpack_public_path__ + "static/imda20183rdprize-0ba1a1c01554cd1fc7ac3a9008480b4a.jpg";